import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/reducers';

export const selectScheduler = createSelector(
  (state: RootState) => state,
  (state) => state.reporting.scheduler
);
